module.exports = __webpack_public_path__ + "img/design.20288514.png";